export default __webpack_public_path__ + "static/media/osmodule.d5d5a480.png";